import { CommonModule, TitleCasePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { HttpService } from './services/http.service';
import { DynamicFieldDirective } from './dynamicform/components/dynamic-field/dynamic-field.directive';
import { DynamicFormComponent } from './dynamicform/dynamic-form/dynamic-form.component';
import { DynamicFormService } from './dynamicform/service/dynamic-form.service';
import { MaterialModule } from '../material-module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormInputComponent } from './dynamicform/components/form-input/form-input.component';
import { FormCheckboxComponent } from './dynamicform/components/form-checkbox/form-checkbox.component';
import { FormTextareaComponent } from './dynamicform/components/form-textarea/form-textarea.component';
import { FormRadioComponent } from './dynamicform/components/form-radio/form-radio.component';
import { FormSelectComponent } from './dynamicform/components/form-select/form-select.component';
import { FormdateComponent } from './dynamicform/components/form-date/form-date.component';
import { ButtonComponent } from './components/button/button.component';
import { ButtonInputFormater } from './pipes/button-input-formatter.pipe';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { SwiperConfigInterface, SwiperModule, SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { PopupComponent } from './components/popup/popup.component';
import { PopupMessageComponent } from './components/popup-message/popup-message.component';
import { FormInputSelectComponent } from './dynamicform/components/form-input-select/form-input-select.component';
import { PhoneNumberFormatDirective } from './directives/phone-number-format.directive';
import { PopupService } from './services/popup.service';
import { FormAutocompleteComponent } from './dynamicform/components/form-autocomplete/form-autocomplete.component';
import { FormAddButtonComponent } from './dynamicform/components/form-add-button/form-add-button.component';
import {
  PerfectScrollbarModule, PerfectScrollbarConfigInterface,
  PERFECT_SCROLLBAR_CONFIG
} from 'ngx-perfect-scrollbar';
import { FormTimeComponent } from './dynamicform/components/form-time/form-time.component';
import { GuestDataComponent } from './components/guest-data/guest-data.component';
import { TextCutterFormater } from './pipes/text-cutter.piper';
import { NumberShortNotation } from './pipes/number-short-notation.pipe';
import { CurrencyDecimalFormatter } from './pipes/currency-decimal.pipe';
import { MatIconModule } from '@angular/material/icon';
import { GuestTitlePipe } from './pipes/guest-title.pipe';
import { CartTemsPopupComponent } from './components/cart-tems-popup/cart-tems-popup.component';
import { AuthRefundPopupComponent } from './components/auth-refund-popup/auth-refund-popup.component';
import { DecimalsOnlyDirective } from './directives/decimals-only.directive';
import { ErrorValidatorComponent } from './components/error-validator/error-validator.component';
import { SafeHtml } from './pipes/safe-html.pipe';
import { ActivityListFilterPipe } from './pipes/activity-list-filter.pipe';
// Swire Change
import { FormChipComponent } from 'src/app/shared/dynamicform/components/form-chip/form-chip.component';
import { FormatSettingsDatePipe } from './pipes/format-settings-date.pipe';
import { LocalizeService } from './services/localize.service';
import { LocalizedDatePipe } from './pipes/localize-date.pipe';
import { DateComparePipe } from './pipes/date-compare.pipe';

// Swire Change

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  wheelPropagation: true,
  minScrollbarLength: 200
};

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto',
  keyboard: {
    enabled: true,
  },
  mousewheel: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  slideToClickedSlide: true,
  loop: false,
  observer: true
};

@NgModule({
    declarations: [
        DynamicFormComponent,
        DynamicFieldDirective,
        FormInputComponent,
        FormCheckboxComponent,
        FormTextareaComponent,
        FormSelectComponent,
        FormdateComponent,
        ButtonComponent,
        ButtonInputFormater,
        TextCutterFormater,
        NumberShortNotation,
        CurrencyDecimalFormatter,
        LocalizedDatePipe,
        FormRadioComponent,
        PopupComponent,
        PopupMessageComponent,
        FormInputSelectComponent,
        PhoneNumberFormatDirective,
        FormAutocompleteComponent,
        FormAddButtonComponent,
        FormTimeComponent,
        GuestDataComponent,
        GuestTitlePipe,
        SafeHtml,
        AuthRefundPopupComponent,
        DecimalsOnlyDirective,
        CartTemsPopupComponent,
        ErrorValidatorComponent,
        ActivityListFilterPipe,
        // Swire Change
        FormChipComponent,
        // Swire Change
        FormatSettingsDatePipe,
        DateComparePipe
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        TranslateModule,
        PopoverModule,
        TooltipModule,
        NgbModule,
        NgScrollbarModule,
        PerfectScrollbarModule,
        MatIconModule,
        SwiperModule
    ],
    providers: [
        HttpService,
        DynamicFormService,
        PopupService,
        LocalizeService,
        TitleCasePipe,
        GuestTitlePipe,
        ActivityListFilterPipe,
        FormatSettingsDatePipe,
        DateComparePipe,
        SafeHtml,
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        },
        {
            provide: SWIPER_CONFIG,
            useValue: DEFAULT_SWIPER_CONFIG,
        },
        LocalizedDatePipe
    ],
    exports: [
        DynamicFormComponent,
        FormInputComponent,
        FormCheckboxComponent,
        FormTextareaComponent,
        FormSelectComponent,
        ErrorValidatorComponent,
        MaterialModule,
        PopoverModule,
        TranslateModule,
        ButtonComponent,
        FormdateComponent,
        ButtonInputFormater,
        TextCutterFormater,
        NumberShortNotation,
        CurrencyDecimalFormatter,
        LocalizedDatePipe,
        TooltipModule, NgbModule,
        NgScrollbarModule,
        FormRadioComponent,
        PopupComponent,
        PopupMessageComponent,
        PhoneNumberFormatDirective,
        FormAutocompleteComponent,
        GuestTitlePipe,
        SafeHtml,
        SwiperModule,
        ActivityListFilterPipe,
        // Swire Change
        FormChipComponent,
        // Swire Change
        FormatSettingsDatePipe,
        DateComparePipe
    ]
})
export class SharedModule { }
